import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown admin-profile" }
const _hoisted_2 = {
  class: "d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = { class: "flex-grow-1 ms-2" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-none d-xxl-block" }
const _hoisted_6 = { class: "d-flex align-content-center" }
const _hoisted_7 = { class: "dropdown-menu border-0 dropdown-menu-end" }
const _hoisted_8 = {
  class: "mobile-greeting d-md-none fw-semibold mb-1",
  style: {"background":"none !important"}
}
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { class: "admin-link ps-0 mb-0 list-unstyled" }

import { computed } from 'vue';
import { authStore } from '@/stores/auth';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminProfile',
  setup(__props) {

const router = useRouter();

const user = computed(() => authStore.user.value);

const firstNameOnly = computed(() => {
  if (user.value && user.value.name) {
    return user.value.name.split(' ')[0];
  }
  return 'Guest';
});

const handleLogout = async () => {
  await authStore.logout();
  // Redirect to login page or home page after logout
  router.push('/');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
        _createElementVNode("span", { class: "rounded-circle wh-40 d-flex align-items-center justify-content-center bg-primary text-white fs-20" }, [
          _createElementVNode("i", { class: "material-symbols-outlined" }, "person")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", null, _toDisplayString(firstNameOnly.value), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, [
        _cache[1] || (_cache[1] = _createTextVNode(" Ciao, ", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(firstNameOnly.value) + "!", 1)
      ]),
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "dropdown-item d-flex align-items-center text-body",
            href: "#",
            onClick: _withModifiers(handleLogout, ["prevent"])
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "logout", -1),
            _createElementVNode("span", { class: "ms-2" }, "Logout", -1)
          ]))])
        ])
      ])
    ])
  ]))
}
}

})